module.exports = __webpack_public_path__ + "static/media/pic4.463a011a.jpg";